<template>
  <div class="content-wrappper">
    <router-view :roleInfo="roleInfo"></router-view>
  </div>
</template>
<script>
import EventBus from '../../utils/event-bus';

export default {
  props: {
    roleInfo: Object
  },
  created() {
    EventBus.$on('languageUpdate', (language, oldLanguage) => {
      if (language !== oldLanguage) {
        this.$router.go();
      }
    });
  }
};
</script>
